import { Box } from '@mui/system'
import React, { Component } from 'react'

export default class Spacer extends Component {
	render() {
		return (
			<Box marginBottom={this.props.space ? this.props.space : 1}></Box>
		)
	}
}